import { handleActions } from 'redux-actions';
import { ActionTypes } from '../actions/loadListings';
import { LoadAdvertiserListingsDone } from '../constants';
import { ListingsGroup } from '../types';

export type State = Readonly<{
  groupedListings: ListingsGroup[];
}>;

const initialState = {
  groupedListings: [],
};

const listingsReducer = handleActions(
  {
    [ActionTypes.DONE]: (state, action: LoadAdvertiserListingsDone) => ({
      ...state,
      groupedListings: action.payload,
    }),
  },
  initialState,
);
export { listingsReducer };
